module.exports = __webpack_public_path__ + "1ece36402ddbbcb83cd67886ab3727ee.pdf";